import { createAction } from '@reduxjs/toolkit';

const postEasyPostShipmentClearError = createAction('postEasyPostShipmentClearError');

export default postEasyPostShipmentClearError;
